<script lang="ts">
	import './global.scss';
	import StepType from './steps/StepType.svelte';
	import Stepper from './components/Stepper.svelte';
	import StepContent from "./steps/StepContent.svelte";
	import StepCaptcha from "./steps/StepCaptcha.svelte";
	import {Utils} from "./util";
	import StepFinish from "./steps/StepFinish.svelte";
	import {Shadow} from "svelte-loading-spinners";
	import {getContext} from "svelte";
	import ErrorModal from "./components/modal/ErrorModal.svelte";
	import type {ModalProps} from "svelte-simple-modal/types/Modal.svelte";
    import StepSource from "./steps/StepSource.svelte";
	import type {ReportType} from "./model";

    declare var lang: string; //this is specified in the index.html file to change the language

    const urlParams = new URLSearchParams(window.location.search);

	let typeID = Number(urlParams.get('report_type')) || null;
    let source = null;
    let otherSource = null;
	let links = [];
	let description = null;
	let email = null;
	let files = [];

	let selectedReportType = "";
	let reportTypes = Utils.get<ReportType[]>('/api/api/stopline-public/report-type')
		.then(types => {
			selectedReportType = Utils.chooseTranslation(types.find(t => t.id == typeID)?.name)

            return types;
		});

	let loading: Promise<any>;

	$: updateSelectedReportType(typeID);
	async function updateSelectedReportType(id: number) {
		let types = await reportTypes;
		selectedReportType = Utils.chooseTranslation(types?.find(t => t.id == typeID)?.name);
    }

	$: if (typeID === 3) clearFiles();

	let currentStep: number;
	let stepTypeValidate: () => boolean;
	let stepSourceValidate: () => boolean;
	let stepContentValidate: () => boolean;
	let stepCaptchaValidate: () => boolean;

	function goTo(e: CustomEvent<number>) {
		if (e.detail <= currentStep) {
			actuallyGoToStep(e.detail);
        } else if (e.detail == currentStep + 1) {
			let valid = false;
			if (currentStep == 1) {
				valid = stepTypeValidate();
			} else if (currentStep == 2) {
				valid = stepSourceValidate();
			} else if (currentStep == 3) {
				valid = stepContentValidate();
			} else if (currentStep == 4) {
				valid = stepCaptchaValidate();
			}

			if (valid) {
				actuallyGoToStep(e.detail);
			}
        }
    }
	let actuallyGoToStep: (step: number) => void;

	const { open } = getContext('simple-modal');
	const showError = (e: { status: string, message?: { errors: { [field: string]: string[] }, message: string } }) => {
		console.log(open, e);
		let title = '';
		let message = '';
		if (e?.message?.errors) {
			const errors = Object.keys(e.message.errors)
				.map(field => `${field}: ${e.message.errors[field].join(', ')}`);
			title = e.message.message;
			message = errors.join('\n');
        } else {
			title = e?.status || 'System Error!';
			message = 'There was a problem with the server. Please repeat your request.';
        }
		open(ErrorModal, { title, message }, {
			styleContent: {
				padding: '0'
			},
			closeButton: false,
		} as ModalProps);

	}

	function clearFiles() {
		files = [];
	}

	function submit() {
        const values = {
            reportType_id: typeID,
            source: source === 'other' ? otherSource : source,
            description,
            links,
            files,
            reporter_lang:lang
        }
        //console.log("values:::");
        //console.log(values);
        // remove null values
        for (let key of Object.keys(values)) {
            if (values[key] == null)
                delete values[key];
        }
		const data = Utils.formValueToFormData(values);
		// data.forEach((entry, key) => console.log(key, entry));
		loading = Utils.post("/api/api/stopline-public/report", data).then(v => v, e => {
			loading = null;
			showError(e);
			throw e;
		});
	}
</script>

{#if loading}
    {#await loading}
        <div class="spinner-wrapper">
            <Shadow size="80" color="#FF3E00" unit="px" duration="1s"></Shadow>
        </div>
    {:then response}
        <StepFinish uniqueID={response.uuid}></StepFinish>
    {/await}
{:else}
    <Stepper on:goTo={goTo} bind:goTo={actuallyGoToStep} reportType={selectedReportType} bind:currentStep>
        <StepType {currentStep} bind:typeID bind:validate={stepTypeValidate} {reportTypes}></StepType>
        <StepSource {currentStep} bind:source bind:otherSource bind:validate={stepSourceValidate}></StepSource>
        <StepContent {currentStep} typeID={typeID}  bind:description bind:links bind:files bind:validate={stepContentValidate}></StepContent>
        <StepCaptcha {currentStep} typeID={typeID}  reportType={selectedReportType} source={source === 'other' ? otherSource : source} {files} {links} {description}
                     on:submit={submit} bind:validate={stepCaptchaValidate}></StepCaptcha>
    </Stepper>
{/if}

<style lang="scss">
    .spinner-wrapper {
        display: flex;
        justify-content: center;
    }
</style>
